import { AppStateType } from "../reducers";

export const getDate = (state: AppStateType) => state.themeReducer.Date;
